import { defineModule } from "@motolynk/app-core";

import en from "./i18n/en.json";

/** The activity log viewer: every entry in the admin panel (User & Security → Activity log), the store's own
 * entries in the vendor panel (Store → Activity log, team code `activity.view`: owners and managers). */
export const auditModule = defineModule({
  name: "audit",
  label: "Activity log",
  requires: ["core", "accounts", "configuration"],
  i18n: { en },
  admin: {
    routes: [
      {
        path: "activity",
        permission: "audit.view_activitylog",
        page: () => import("./ActivityPage"),
      },
    ],
    nav: [
      {
        id: "activity",
        group: "usersSecurity",
        label: "audit:nav",
        icon: "clipboard",
        to: "/activity",
        permission: "audit.view_activitylog",
        order: 3,
      },
    ],
  },
  vendor: {
    routes: [
      {
        path: "activity",
        permission: "activity.view",
        page: () => import("./vendor/StoreActivityPage"),
      },
    ],
    nav: [
      {
        id: "store-activity",
        group: "store",
        label: "audit:nav",
        icon: "clipboard",
        to: "/activity",
        permission: "activity.view",
        order: 3,
      },
    ],
  },
});
